import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/services/toxicology/pde-oel-reports")({
  beforeLoad: () => { throw redirect({ href: "/zh-cn/services/regulatory-toxicology/pde-oel-reports", statusCode: 301 }); },
});
